import API from '../../../helpers/request/api';

const api = () => new API();

const fetchCurrent = () => {
  const query = {
    query: `{
      current_post {
        id
        slug
      }
    }`,
  };

  return api().get(query);
};

const fetchFromCategory = (category) => {
  const postIds = category.published_posts.map(post => post.id);

  const query = {
    query: `{
      posts_by_ids(ids: [${postIds}]) {
        id
        category {
          id
        }
        user_post {
          status
        }
      }
    }`,
  };

  return api().get(query);
};

export default {
  fetchCurrent,
  fetchFromCategory,
};




// WEBPACK FOOTER //
// ./src/screens/Index/queries/posts.js